import { httpBatchLink, httpLink, loggerLink, splitLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '../../../back/app.ts';
import { trpcTransformer } from '../../../shared/utils/trpcTransformer.ts';
import { fetchWithErrorLog } from './fetchWithErrorLog.ts';
import { withGuard } from './trpcLinks.ts';

export const trpc = createTRPCReact<AppRouter>();

const defaultLink = {
    url: '/trpc',
    transformer: trpcTransformer,
    fetch: fetchWithErrorLog,
    headers: () => ({ 'x-client-version': import.meta.env.APP_VERSION }),
};
const defaultBatchLink = {
    ...defaultLink,
    maxURLLength: 2000,
};

export const trpcClient = trpc.createClient({
    links: [
        loggerLink({
            enabled: () => import.meta.env.MODE === 'development',
        }),
        splitLink({
            // Endpoints that avoid being batched together with long queries
            condition: (op) => op.path.startsWith('shiftMetrics.')
                || op.path === 'operators.getOperatorCountsForReport'
                || op.path === 'operators.getOperatorActivityForReportDay',
            true: withGuard(() =>
                httpLink({
                    ...defaultLink,
                }),
            ),
            false: splitLink({
                // Long query condition
                condition: (op) => op.path === 'batches.getPartsCountsAtTimes' || op.path === 'equipments.testCncSignals',
                // Force POST for long queries
                true: withGuard(() =>
                    httpLink({
                        ...defaultLink,
                        methodOverride: 'POST',
                    }),
                ),
                // Default: use GET
                false: splitLink({
                    condition: (op) => op.path.startsWith('protocolFiles.'),
                    true: withGuard(() => httpBatchLink(defaultBatchLink)),
                    false: withGuard(() => httpBatchLink(defaultBatchLink)),
                }),
            }),
        }),
    ],
});
